// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MobileFilledSvg from "@ant-design/icons-svg/es/asn/MobileFilled";
import AntdIcon from '../components/AntdIcon';

var MobileFilled = function MobileFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MobileFilledSvg
  }));
};

MobileFilled.displayName = 'MobileFilled';
export default React.forwardRef(MobileFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/MobileFilled.js
// module id = 1501
// module chunks = 0